import axiosInstance from "../axiosInstance";
import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const totalvideoListCopywritersDashboard = (data, page) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      //   `${endpoints.Editor.editorList}?status=${page?.status}&search=${page?.search}&published_at_from=${page?.startDate}&published_at_to=${page?.endDate} &page=${data}`

      `${endpoints.copyWritersDashboard.videolist}?urgent_request=1&page=${data}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const totalvideoListCopywritersDashboard1 = (data, page) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      //   `${endpoints.Editor.editorList}?status=${page?.status}&search=${page?.search}&published_at_from=${page?.startDate}&published_at_to=${page?.endDate} &page=${data}`

      `${endpoints.copyWritersDashboard.videolist}?revision_request=1&page=${data}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const CopywritersDashboardpendingtitlingpageMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.copyWritersDashboard.videolist}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const CopywritersDashboardPendingRevisionMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.copyWritersDashboard.videolist}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CopywritersDashboardCompletedVideoMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.copyWritersDashboard.videolist}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CopywritersDashboardpendingtitlingpageMutation1 = async (
  datas
) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.copyWritersDashboard.videolist}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const CopywritersProfileUpdateMutation = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.copyWritersDashboard.updateUser,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

// export const getcopywritersdashboardSubmission = async (data) => {
//   try {
//     const res = await axiosInstance.post(`${endpoints.copyWritersDashboard.submissions}`, data);
//     return res;
//   } catch (error) {
//     return error.message;
//   }
// };

export const Copywriterssubmissionsmutation = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.cms.Copywriterssubmissions,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const FeedbackMutationF = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.copyWritersDashboard.feedback,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const searchDataCallCopywriters = (query, pageParam) => {
  console.warn("🚀 ~ file: cms.api.js:24 ~ submissionsList ~ body:", query);
  return new Promise((resolve, reject) => {
    ApiRequest.post(
      `${endpoints.copyWritersDashboard.videolist}?search=${query}&page=${pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
